import { PlanType, RolType, PermissionType } from '@dataclouder/app-auth';
import { IAIModel } from '@dataclouder/ngx-core';

export interface ConversationSettings {
  synthVoice: boolean;
  voice: string;
  highlightWords: boolean;
  realTime: boolean;
  repeatRecording: boolean;
  fixGrammar: boolean;
  superHearing: boolean;
  autoTranslate: boolean;
  model: IAIModel;
  speed: number;
}

export interface PersonalData {
  firstname: string;
  lastname: string;
  gender: string;
  birthday: string | Date;
  emotionalName?: string;
}

export enum StateStep {
  Taken = 'taken',
  Skipped = 'skipped',
  Pending = 'pending',
}

export interface User {
  id: string;
  name: string;
  email: string;
  settings: UserSettings;
  claims: UserClaims;
  languageProgress: any;
  recommendations: any;
  frontendSteps?: FrontendSteps;
  personalData?: PersonalData;
  urlPicture: string;
  authStrategy: string;
  // Add other user properties as needed
}

export class FrontendSteps {
  introTaken?: StateStep;
  homeTourState?: StateStep;
  verbsTourState?: StateStep;
}

export interface UserSettings {
  targetLanguage: string;
  baseLanguage: string;
  conversation?: ConversationSettings;
  // Add other settings properties as needed
}

export interface UserClaims {
  plan: Plan;
  roles: { [key in RolType]?: string | null };
  permissions: PermissionClaim;
}

export type PermissionClaim = Record<PermissionType, { exp: Date; num: number }>;

export interface Plan {
  type: PlanType;
  exp: string | null;
}
